import { ModuleLayout } from '@billy/design-system'
import type { HelpCenterLayoutSlots } from '@shinetools/virtual-assistant-client'
import { ReactElement } from 'react'

import { HelpCenter, VirtualAssistantHost } from '@features/virtualAssistant'

const renderModuleLayout = ({ content, sideActions, title }: HelpCenterLayoutSlots): ReactElement => (
  <ModuleLayout sideActions={sideActions} title={title}>
    {content}
  </ModuleLayout>
)

export const HelpCenterPage = (): ReactElement => (
  <VirtualAssistantHost>
    <HelpCenter renderLayout={renderModuleLayout} />
  </VirtualAssistantHost>
)
